/**
 * If you are not familiar with React Navigation, refer to the "Fundamentals" guide:
 * https://reactnavigation.org/docs/getting-started
 *
 */
import { useEffect, useState } from 'react';
import { ActivityIndicator, View, Text } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useDispatch } from 'react-redux'
import { RootStackParamList } from '../types';
import LinkingConfiguration from './LinkingConfiguration';

import DashboardScreen from '../screens/Dashboard';
import NotFoundScreen from '../screens/NotFoundScreen';
import SettingsScreen from '../screens/SettingsScreen';
import SinginScreen from '../screens/SinginScreen';
import SingupScreen from '../screens/SingupScreen';
import ResourcesScreen from '../screens/Resources'

import { auth } from '../services/connect';
import UserService from '../services/user';
import { setUser } from '../services/store/common';
import IUserModel from '../services/models/user';
import { DocumentData, DocumentSnapshot } from 'firebase/firestore';

const userService = new UserService();

export default function Navigation() {
	return (
		<NavigationContainer linking={LinkingConfiguration}>
			<RootNavigator />
		</NavigationContainer>
	);
}

/**
 * A root stack navigator is often used for displaying modals on top of all other content.
 * https://reactnavigation.org/docs/modal
 */
const Stack = createNativeStackNavigator<RootStackParamList>();

function RootNavigator() {
	const dispatch = useDispatch();
	
	const [logged, setLogged] = useState<boolean | null>(null);

	useEffect(()=>{
		auth.onAuthStateChanged(async (data) => {
			if(!data) {
				return setLogged(false);
			}

			setLogged(true);
			userService.getRealtime(data.uid, (snap: DocumentSnapshot<DocumentData>) => {
				const userData = snap.data() as IUserModel;
				dispatch(setUser(userData));
			});
		});
	}, []);

	if (logged === null) {
		return (
			<View style={{ height: '100%', justifyContent: 'center', alignItems: 'center' }}>
				<ActivityIndicator size='large' color='#000' />
				<Text style={{ marginTop: 40, fontSize: 32 }}>Loading</Text>
			</View>
		)
	}

	if (!logged) {
		return (
			<Stack.Navigator>
				<Stack.Screen name="Singin" component={SinginScreen} options={{ headerShown: false }} />
				<Stack.Screen name="SingUp" component={SingupScreen} options={{ headerShown: false }} />
			</Stack.Navigator>
		)
	}

	return (
		<Stack.Navigator>
			<Stack.Screen name="DashBoard" component={DashboardScreen} options={{ headerShown: false }} />
			<Stack.Screen name="Settings" component={SettingsScreen} options={{ headerShown: false }} />
			<Stack.Screen name="Resources" component={ResourcesScreen} options={{ headerShown: false }} />
			<Stack.Screen name="NotFound" component={NotFoundScreen} options={{ title: 'Oops!' }} />
		</Stack.Navigator>
	);
}
